export const getIconSize = (element: HTMLElement | null) => {
  if (!element) return 16;

  const computedStyle = globalThis.getComputedStyle(element);
  const fontSize = Number.parseFloat(computedStyle.fontSize);

  // For text bigger than 16pt (approximately 21.33px), use 24px icon
  return fontSize > 21.33 ? 24 : 16;
};
